import React, { useContext, useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import Fontawesome from "../../../../components/fontawesome/fontawesome";
import {
  LocationMonitoring,
  Location,
  TotalItems,
  Button,
  Chip,
  Status,
  StatusText,
  ButtonIcon,
  Rotate,
  CardRoom,
} from "./styles";

import { useFetch } from "../../../../../components/hooks/useFetch";
import { Prefix } from "../../../../../services/prefix";
import { LiaMapMarkedAltSolid } from "react-icons/lia";
import Loading from "../../../../../components/loader/loading";
import { StoreContext } from "../../../../../stores/inject";
import { observer } from "mobx-react-lite";
import RoomMonitoring from "../RoomMonitoring";

const RoomMonitoringV2 = ({
  idUnit,
  unit,
  nameUnit,
  idRoom,
  idSector,
  customerName,
  idCustomer,
  filter,
  toggleModalPlan,
  setContractItems,
  setAllRoomsUnits,
  newValueContractItem,
}) => {
  const { sensorStore, roomStore } = useContext(StoreContext);
  const [opens, setOpens] = useState([]);
  const [allRooms, setAllRooms] = useState({});

  function handleOpen(id) {
    setOpens((state) =>
      state.includes(id) ? state.filter((it) => it !== id) : [...state, id]
    );
  }

  function isOpen(id) {
    return opens.includes(id);
  }

  const open = isOpen(idRoom);

  const params = Object.entries({
    sector: idSector,
    room: idRoom,
  })
    .filter(([, value]) => !!value)
    .map(([key, value]) => `${key}=${value}`)
    .join("&");

  const realUrl = `${Prefix.replace(/[\\"]/g, "")}/sismogran/map/units/${idUnit}/rooms?${params}`;
  const path = open ? realUrl : null;

  const listRooms = useFetch(path);

  useEffect(() => {
    if (!open) return;
    if (!listRooms.data?.models) return;

    setAllRooms((state) => ({ ...state, [idUnit]: listRooms.data.models }));

    setAllRoomsUnits((state) => [
      ...(state || []),
      ...(listRooms.data.models || []),
    ]);
  }, [open, idUnit, listRooms.data, newValueContractItem, setAllRoomsUnits]);

  const totalSensors =
    (unit?.situations?.SUCCESS || 0) +
    (unit?.situations?.WARNING || 0) +
    (unit?.situations?.DANGER || 0) +
    (unit?.situations?.DARK || 0);

  const hasRooms =
    listRooms.data?.models && listRooms.data.models.length > 0;

  return (
    <Col style={{ margin: 5 }}>
      <LocationMonitoring>
        <Location className="d-flex">
          <div className="d-flex align-items-center gap-1">
            {Prefix.includes("admin") && unit.customer_name} &gt; {nameUnit}
          </div>
          {unit.unit_plant_path && (
            <div>
              <Button
                onClick={() => {
                  sensorStore.setSelected(unit);
                  toggleModalPlan();
                }}
              >
                <LiaMapMarkedAltSolid size={24} />
              </Button>
            </div>
          )}
        </Location>

        <div style={{ display: "flex", gap: 5 }}>
          <LocationMonitoring style={{ justifyContent: "center", paddingLeft: 0 }}>
            <Chip active={filter === "SUCCESS"} situation="SUCCESS">
              <Status src="/media/icons/green-light.svg" />
              <StatusText>{unit?.situations?.SUCCESS || "--"}</StatusText>
              <Fontawesome classe="fas fa-chevron-down mr-2 ml-2" />
            </Chip>

            <Chip active={filter === "WARNING"} situation="WARNING">
              <Status src="/media/icons/yellow-light.svg" />
              <StatusText>{unit?.situations?.WARNING || "--"}</StatusText>
              <Fontawesome classe="fas fa-chevron-down mr-2 ml-2" />
            </Chip>

            <Chip active={filter === "DANGER"} situation="DANGER">
              <Status src="/media/icons/red-light.svg" />
              <StatusText>{unit?.situations?.DANGER || "--"}</StatusText>
              <Fontawesome classe="fas fa-chevron-down mr-2 ml-2" />
            </Chip>

            <Chip active={filter === "DARK"} situation="DARK">
              <Status src="/media/icons/black-light.svg" />
              <StatusText>{unit?.situations?.DARK || "--"}</StatusText>
              <Fontawesome classe="fas fa-chevron-down mr-2 ml-2" />
            </Chip>
          </LocationMonitoring>

          <TotalItems>
            <Button onClick={() => handleOpen(idRoom)}>
              <strong>{totalSensors}</strong>
              <div style={{ marginLeft: 4 }}>Sensores</div>
              <ButtonIcon>
                <Rotate open={open}>
                  <Fontawesome classe="fas fa-chevron-down mr-2 ml-2" />
                </Rotate>
              </ButtonIcon>
            </Button>
          </TotalItems>
        </div>
      </LocationMonitoring>

      {open && (
        <CardRoom>
          {!listRooms.data ? (
            <Loading />
          ) : hasRooms ? (
            <RoomMonitoring
              idUnit={unit.id}
              nameUnit={unit.name}
              showNameUnit
              idCustomer={idCustomer}
              idSector={idSector}
              idRoom={idRoom}
              customerName={customerName}
              setAllRooms={setAllRooms}
              filter={filter}
              toggleModalPlan={toggleModalPlan}
              newValueContractItem={newValueContractItem}
            />
          ) : (
            <div
              style={{
                textAlign: "center",
                padding: 20,
                display: "flex",
                flexDirection: "column",
                gap: 8,
              }}
            >
              <strong>Nenhum registro encontrado</strong>
              <span>Não existem salas cadastradas para esta unidade</span>
            </div>
          )}
        </CardRoom>
      )}
    </Col>
  );
};

export default observer(RoomMonitoringV2);
